const RESET_PASSWORD_PREFIX = '/resetPassword/';
const RESET_PASSWORD_ROUTE = '/resetPassword';
const TOKEN_PATTERN = /^[A-Za-z0-9_-]{43}$/;

let pendingRecoveryLink = null;

const normalizeToken = (rawToken) => {
  try {
    return decodeURIComponent(rawToken).trim();
  } catch {
    return null;
  }
};

export const capturePasswordRecoveryLink = ({ location, history } = {}) => {
  const currentLocation = location || window.location;
  const currentHistory = history || window.history;
  const { pathname = '', search = '' } = currentLocation;

  if (!pathname.startsWith(RESET_PASSWORD_PREFIX)) return false;

  const rawToken = pathname.slice(RESET_PASSWORD_PREFIX.length);
  const token = normalizeToken(rawToken);
  const tokenIsValid = TOKEN_PATTERN.test(token || '');
  const params = new URLSearchParams(search);
  pendingRecoveryLink = {
    token: tokenIsValid ? token : null,
    status: tokenIsValid ? null : 'malformed',
    mode: params.has('create') ? 'create' : 'recovery',
  };

  currentHistory.replaceState(currentHistory.state, '', RESET_PASSWORD_ROUTE);
  return true;
};

export const consumePasswordRecoveryLink = () => {
  const captured = pendingRecoveryLink;
  pendingRecoveryLink = null;
  return captured;
};

export const isPasswordRecoveryRoute = (pathname = window.location.pathname) =>
  pathname === RESET_PASSWORD_ROUTE || pathname.startsWith(RESET_PASSWORD_PREFIX);

export const sanitizePasswordRecoveryPath = (pathname, search = '') =>
  isPasswordRecoveryRoute(pathname) ? RESET_PASSWORD_ROUTE : `${pathname}${search}`;

export const resetPasswordRecoveryLinkForTests = () => {
  pendingRecoveryLink = null;
};
